import { updateDesignParameter } from "../../../../Features/designParameter";
import { panelInformation } from "../../../DataFiles/panelInformation";
import { calculatedRotateStructure } from "../canvasFunction";
import { roofStructureData } from "../structureFunction";
import { calculateCustomizedStructure } from "./customizedStructure";
import {
  calculatedCustomStructure,
  handleImageDimension,
} from "./customizeStructurePlacement";
import { calculateCarportStructure } from "./doubleCarportPlacement";
import { calculateLandscapePlacement } from "./landscapeStructure";
import { calculatePortraitPlacement } from "./portraitStructure";
import {
  getPixelsPerMeter,
  mulImgDelete,
  rotatedImgDelete,
  strImgDeleted,
} from "./smithStructure";

export const handleDeleteImg = ({
  selectedImage,
  setSelectedImage,
  dispatch,
  quantityInfo,
  setDrag,
  roofInfo,
  designParameter,
}) => {
  setDrag(false);
  dispatch(
    updateDesignParameter({
      drawPolygon: false,
      drawAbstacle: false,
    })
  );
  if (!selectedImage || selectedImage.length === 0) {
    alert("Select structure(s) that you want to delete");
    return false;
  }

  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const structureItem = roofStructureData.find(
    (item) => item.name === roofDetail.mountingStructure
  );

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  if (roofDetail.newStructure) {
    if (roofDetail.azimuth !== 180) {
      rotatedImgDelete({
        dispatch,
        quantityInfo,
        roofInfo,
        selectedImage,
        panel,
        structureItem,
      });
    } else {
      if (roofDetail.structureType === "Multiple") {
        mulImgDelete({
          dispatch,
          quantityInfo,
          roofInfo,
          selectedImage,
          panel,
          structureItem,
        });
      } else {
        strImgDeleted({
          dispatch,
          quantityInfo,
          roofInfo,
          selectedImage,
          panel,
          structureItem,
        });
      }
    }
    return false;
  }

  if (roofDetail.azimuth !== 180 && !roofDetail.customizeStructure) {
    rotatedImageDelete({ dispatch, quantityInfo, roofInfo, selectedImage });
    return false;
  }

  const images = roofDetail?.images || [];

  const newImages = [...images];

  if (Array.isArray(selectedImage)) {
    selectedImage.forEach((image) => {
      const indexToDelete = newImages.findIndex((img) => img.id === image.id);
      if (indexToDelete !== -1) {
        newImages.splice(indexToDelete, 1);
      }
    });
  } else {
    const indexToDelete = newImages.findIndex(
      (img) => img.id === selectedImage.id
    );
    if (indexToDelete !== -1) {
      newImages.splice(indexToDelete, 1);
    }
  }

  setSelectedImage([]);

  if (roofDetail.customizeStructure) {
    const imgDimension = handleImageDimension({
      roofInfo,
      roofDetail,
      designParameter,
    });
    calculatedCustomStructure({
      newImages,
      dispatch,
      roofDetail,
      quantityInfo,
      imgDimension,
    });
  } else {
    const walkWayImages = roofDetail?.walkwayPlacement || [];
    if (
      structureItem.name === "Smith Pro L" ||
      structureItem.name === "Smith Through Rail L"
    ) {
      console.log("hiii");
      calculateLandscapePlacement({
        newImages,
        walkWayImages,
        structureItem,
        dispatch,
        roofDetail,
        quantityInfo,
      });
    } else if (
      structureItem.name === "Smith Pro P" ||
      structureItem.name === "Smith Through Rail P"
    ) {
      calculatePortraitPlacement({
        newImages,
        walkWayImages,
        structureItem,
        dispatch,
        roofDetail,
        quantityInfo,
      });
    } else if (structureItem.roofType === "Carport") {
      calculateCarportStructure({
        newImages,
        structureItem,
        dispatch,
        roofDetail,
        quantityInfo,
      });
    } else if (structureItem.name === "Customized") {
      calculateCustomizedStructure({
        newImages,
        structureItem,
        dispatch,
        roofDetail,
        quantityInfo,
      });
    }
  }
};

const rotatedImageDelete = ({
  dispatch,
  quantityInfo,
  roofInfo,
  selectedImage,
}) => {
  const roofNo = quantityInfo.roofNo;
  const roofData = quantityInfo?.roofData || [];
  const roofDetail = roofData[roofNo];

  if (roofDetail.azimuth !== 180) {
    let pixelMultiple = getPixelsPerMeter(roofInfo);
    const structureItem = roofStructureData.find(
      (item) => item.name === roofDetail.mountingStructure
    );
    const imgDimension = {
      height: structureItem.height * pixelMultiple,
      width: structureItem.width * pixelMultiple,
      gap: (roofDetail.rowDistance / 1000) * pixelMultiple,
    };
    let proP = roofDetail.proP;
    proP = Object.values(proP);
    const azimuth = roofDetail.azimuth;
    let newImages = roofDetail.images;
    if (Array.isArray(selectedImage)) {
      selectedImage.forEach((image) => {
        newImages = newImages.filter((img) => img.x !== image.x);
        // Delete from proP as well
        let proPTemp = [];
        proP.forEach((item) => {
          let temp = item.filter((img) => (img?.currX ?? img.x) !== image.x);
          if (temp.length > 0) {
            proPTemp.push(temp);
          }
        });
        proP = proPTemp;
      });
    } else {
      newImages = newImages.filter((img) => img.x !== selectedImage.x);
      // Delete from proP as well
      let proPTemp = [];
      proP.forEach((item) => {
        let temp = item.filter(
          (img) => (img?.currX ?? img.x) !== selectedImage.x
        );
        if (temp.length > 0) {
          proPTemp.push(temp);
        }
      });
      proP = proPTemp;
    }

    calculatedRotateStructure({
      newImages,
      proP,
      imgDimension,
      structureItem,
      dispatch,
      quantityInfo,
      roofInfo,
      roofDetail,
      azimuth,
    });
  }
};


